/**
 * Check if the user is currently typing in an input field
 * to prevent keyboard shortcuts from interfering with text input
 */
export const isUserTyping = (event: KeyboardEvent): boolean => {
  const target = event.target as HTMLElement;
  
  return (
    target.tagName === 'INPUT' ||
    target.tagName === 'TEXTAREA' ||
    target.isContentEditable ||
    // Check for specific input types that should block shortcuts
    (target as HTMLInputElement).type === 'text' ||
    (target as HTMLInputElement).type === 'search' ||
    (target as HTMLInputElement).type === 'email' ||
    (target as HTMLInputElement).type === 'password' ||
    (target as HTMLInputElement).type === 'tel' ||
    (target as HTMLInputElement).type === 'url'
  );
};

/**
 * Check if any input field is currently focused
 */
export const isInputFocused = (): boolean => {
  const activeElement = document.activeElement;
  
  if (!activeElement) return false;
  
  return (
    activeElement.tagName === 'INPUT' ||
    activeElement.tagName === 'TEXTAREA' ||
    (activeElement as HTMLElement).isContentEditable
  );
};
